<template>
  <div>
    <Breadcrumb :style="{ margin: '20px 10px' }">
      <BreadcrumbItem>礼品卡管理</BreadcrumbItem>
      <BreadcrumbItem>礼品卡订单</BreadcrumbItem>
    </Breadcrumb>
    <loading :loading="loading" :error="error"></loading>
    <Form ref="selectForm" :model="selectForm" inline>
      <FormItem prop="category_id">
        <Select
            v-model="selectForm.category_id"
            clearable
            multiple
            filterable
            style="width: 250px; margin-right: 10px; margin-left: 10px"
            @on-query-change="handleInput"
            @on-change="handleSelectChange"
            ref="select"
        >
          <Option
              v-for="category in categories"
              :value="category.category_id"
              :key="category.category_id"
          >{{ category.title }}</Option
          >
        </Select>
      </FormItem>
      <FormItem prop="templet_no">
        <Input v-model="selectForm.gift_card_asn" placeholder="礼品券编号"></Input>
      </FormItem>
      <FormItem prop="status">
        <Select
            v-model="selectForm.status"
            clearable
            placeholder="请选择状态"
            style="width: 150px; margin-right: 10px"
        >
          <Option value="0">已发放</Option>
          <Option value="1">已核销</Option>
          <!--          <Option value="2">已绑定</Option>-->
          <Option value="3">已废弃</Option>
          <Option value="4">已过期</Option>
        </Select>
      </FormItem>
      <FormItem>
        <Button type="primary" @click="handleSubmit('selectForm')">查询</Button>
        <!--        <Button type="primary" @click="goExportII()" style="margin-left: 5px;">导出</Button>-->
      </FormItem>
    </Form>
    <Table border stripe :columns="columns1" :data="list">
      <template slot-scope="{ row }" slot="status">
        <span v-if="row.status === 0">已发放</span>
        <span v-else-if="row.status === 1">已核销</span>
        <span v-else-if="row.status === 2">已绑定</span>
        <span v-else-if="row.status === 3">已废弃</span>
        <span v-else-if="row.status === 4">已过期</span>
        <span v-else>-</span>
      </template>
      <template slot-scope="{ row, index }" slot="action">
        <Button type="primary" size="small" style="margin: 5px" @click="show(row,index)">详情</Button>
        <Button
            type="primary"
            size="small"
            style="margin: 5px"
            :loading="!!row._statusLoading"
            @click="getOrderState(row, index)"
        >查询状态</Button>
      </template>
    </Table>
    <Page style="margin: 10px; text-align:center;" @on-change="pageOnChange" :total="pages.total" :page-size="pages.per_page" show-elevator prev-text="上一页" next-text="下一页" />
  </div>
</template>

<script>
import loading from "../loading";
export default {
  name: "card_orders",
  components: { loading },
  data () {
    return {
      loading: false,
      error: null,
      list: [],
      selectForm: {
        category_id: '',
        status: '',
        gift_card_asn: ''
      },
      categories: null,
      pages: {},
      columns1: [
        { align: "center", title: '礼品券编号', key: 'gift_card_asn', minWidth: 100 },
        { align: "center", title: '券码', key: 'voucher', minWidth: 100 },
        { align: "center", title: '三方订单号', key: 'box_order_no', minWidth: 100 },
        { align: "center", title: '会员编码', key: 'member_no', minWidth: 100 },
        { align: "center", title: '手机号', key: 'phone', minWidth: 100 },
        { align: "center", title: '状态', slot: 'status', minWidth: 80 },
        { align: "center", title: '操作', slot: 'action', width: 200 }
      ],
    }
  },
  created () {
    console.log('this.$route.query=>', this.$route.query);
    if ('gift_card_asn' in this.$route.query) {
      this.selectForm.gift_card_asn = this.$route.query.gift_card_asn;
    }
    this.fetchData('giftCard/orderList', this.$route.query);
    this.axios.get("couponCategories/giftTotalList").then((res) => {
      console.log("res", res);
      this.categories = res.data.coupon_categories;
      this.loading = false;
    });
  },
  methods: {
    handleInput(e) {
      this.lastSearchQuery = e;
    },
    handleSelectChange() {
      let input = this.lastSearchQuery;
      setTimeout(() => {
        this.$refs.select.setQuery(input);
      }, 300);
    },
    handleSubmit: function (name) {
      this.$refs[name].validate((valid) => {
        if (valid) {
          this.fetchData('giftCard/orderList', this.selectForm);
        } else {
          this.$Message.error('出错了');
        }
      })
    },
    pageOnChange: function (page) {
      console.log('page=>', page);
      let url = 'giftCard/orderList?page=' + page;
      this.fetchData(url, this.selectForm);
    },
    fetchData: function (url, param) {
      let data = {};
      for (let key in param) {
        console.log('param[key],', param[key]);
        if (param[key] === undefined || param[key].length == 0) {
          delete param[key];
        }
      }
      data.params = param;
      this.loading = true;
      this.axios.get(url, data).then(res => {
        this.list = res.data.gift_card_detail;
        this.list.forEach(element => {
          element._expanded = false;
          element._statusLoading = false;
        });
        this.pages = res.data.meta;
        this.loading = false;
      })
    },
    show(row, index) {
      console.log("row=>", row.id);
      console.log("index=>", index);
      let params = this.selectForm;
      params.page = this.pages.current_page;
      this.$router.push({
        path: "/pages/gift_card_detail/" + row.id,
        query: params,
      });
    },

    /**
     * 查询单条订单状态：只更新当前行，不刷新列表、不重置分页
     */
    getOrderState(row, index) {
      if (!row.id) {
        this.$Message.warning('订单ID不存在');
        return;
      }

      // 行级 loading，避免整页 loading 闪烁
      this.$set(row, '_statusLoading', true);

      this.axios
          .get(`giftCard/getOrderState/${row.id}`)
          .then((res) => {
            const result = res.data || {};

            // 兼容 code === 0 / 200 两种成功约定
            if (result.code !== undefined && result.code !== 0 && result.code !== 200) {
              this.$Message.error(result.message || '查询状态失败');
              return;
            }

            // 兼容返回结构：{ data: {...} } 或直接就是订单对象
            const data = result.data || result;

            if (data.status === undefined) {
              this.$Message.warning('接口未返回状态字段');
              return;
            }

            // ✅ 仅更新当前行 status，不触发列表重新加载
            this.$set(this.list[index], 'status', data.status);

            // 如果接口顺带返回了其它字段，按需局部合并（默认开启下方逻辑）
            const patchKeys = ['box_order_no', 'member_no', 'phone', 'gift_card_asn', 'category_id'];
            patchKeys.forEach((k) => {
              if (data[k] !== undefined && data[k] !== this.list[index][k]) {
                this.$set(this.list[index], k, data[k]);
              }
            });

            this.$Message.success(`当前状态：${this.getStatusText(data.status)}`);
          })
          .catch((err) => {
            console.error('查询订单状态失败：', err);
            this.$Message.error('查询状态失败，请稍后重试');
          })
          .finally(() => {
            this.$set(row, '_statusLoading', false);
          });
    },

    /**
     * 状态码 -> 文本
     */
    getStatusText(status) {
      const map = {
        0: '已发放',
        1: '已核销',
        2: '已绑定',
        3: '已废弃',
        4: '已过期'
      };
      return map[status] || '-';
    }
  }
}
</script>

<style scoped>

</style>